import React from 'react';
import { NAMES_TEXT } from '@/lib/side';

const FooterBlock = () => {
  return (
    <footer className="footer bg-[var(--midnight)] text-[var(--bone)] py-20 text-center relative z-10 px-6 overflow-hidden">
      <img src="/brand/logo.png" alt="Sonakshi & Shubham" className="w-24 md:w-28 h-auto mx-auto mb-6" />
      <div className="names font-serif text-2xl tracking-wide mb-2">{NAMES_TEXT}</div>
      <div className="font-display italic text-xl text-gold-light mb-12">#SonaKaRaj</div>
      <div className="small text-xs tracking-wider text-[var(--bone)]/40 flex flex-col gap-2">
        {/* #ShuShi: SHUbham + sonakSHI */}
        <div>© 2025 #shushi · Designed with love for Sonakshi by Shubham</div>
      </div>
    </footer>
  );
};

export default FooterBlock;
